


<template>
    <div class="input-group spinner">
        <input type="number" :name="inputName" :id="inputId" class="form-control" :min="minValue" :max="maxValue" v-model="currentValue"
               @keydown="checkKey">
        <div class="input-group-btn-vertical">
            <button class="btn btn-default" type="button" @click="increase"><i class="fa fa-caret-up"></i></button>
            <button class="btn btn-default" type="button" @click="decrease"><i class="fa fa-caret-down"></i></button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NumberInputSpinner",
        data: function() {
            return {
                currentValue: this.value,
                allowedKeys: ["Backspace", "Delete", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"],
            }
        },
        props: {
            inputId: {
                type: String,
                default: 'numberInput',
            },
            inputName: {
                type: String,
                default: 'numberInput',
            },
            value: {
                type: Number,
                default: 0,
            },
            maxValue: {
                type: Number,
                default: 100,
            },
            minValue: {
                type: Number,
                default: 0,
            },
        },
        beforeMount() {
            this.currentValue = this.checkValue(this.value);
        },
        methods: {
            increase: function () {
                if( typeof this.currentValue == "string"){
                    this.currentValue = this.checkValue(parseInt(this.currentValue, 10) + 1);
                } else {
                    this.currentValue = this.checkValue(this.currentValue + 1);
                }
            },
            decrease: function () {
                if( typeof this.currentValue == "string"){
                    this.currentValue = this.checkValue(parseInt(this.currentValue, 10) - 1);
                } else {
                    this.currentValue = this.checkValue(this.currentValue - 1);
                }
            },
            checkValue: function(currentValue){
                if( currentValue > this.maxValue){
                    currentValue = this.maxValue;
                } else if (currentValue < this.minValue){
                    currentValue = this.minValue;
                }
                return currentValue;
            },
            checkKey: function (event) {
                if( this.allowedKeys.indexOf(event.key) < 0) {
                    if (event.key.match(/\d/) === null) {
                        event.preventDefault();
                    }
                }

                if( event.key === "ArrowUp"){
                    this.increase();
                } else if( event.key === "ArrowDown"){
                    this.decrease();
                }
            },
        },
        watch: {
            currentValue: function currentValue(newValue, oldValue) {
                this.currentValue = this.checkValue(newValue);
                this.$emit('input', parseInt(newValue));
            }
        }

    }
</script>

<style scoped>
    .spinner input {
        text-align: right;
    }
    .input-group-btn-vertical {
        position: relative;
        white-space: nowrap;
        width: 1%;
        vertical-align: middle;
        display: table-cell;
    }
    .input-group-btn-vertical > .btn {
        display: block;
        float: none;
        width: 100%;
        max-width: 100%;
        padding: 8px;
        margin-left: -1px;
        position: relative;
        border-radius: 0;
    }
    .input-group-btn-vertical > .btn:first-child {
        border-top-right-radius: 4px;
    }
    .input-group-btn-vertical > .btn:last-child {
        margin-top: -2px;
        border-bottom-right-radius: 4px;
    }
    .input-group-btn-vertical i{
        position: absolute;
        top: 0;
        left: 4px;
    }
    input[type="number"],
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -moz-appearance: none;
        -webkit-appearance: none;
        margin: 0;
    }
</style>